module.exports = __webpack_public_path__ + "img/10.f59fd72a.png";